<script>
  import EButton from '@/components/EButton'

  export default {
    name: 'Tool',
    components: {
      EButton
    },
    props: {
      tool: {
        type: Object,
        default: () => ({})
      }
    },

  }
</script>

<template>
  <div class="border border-gray-250 rounded-lg p-6 bg-white">
    <h2 class="text-2xl md:text-3xl font-bold mb-4">
      {{ tool.fields.title }}
    </h2>
    <p class="text-blue-500 font-bold mb-4 text-xs">
      {{ tool.fields.subtitle }}
    </p>
    <p class="text-base">
      {{ tool.fields.description }}
    </p>
    <nuxt-link :to="tool.fields.buttonLink">
      <e-button
        class="mt-4 mb-2"
        type="quinary"
      >
        {{ tool.fields.buttonText }}
      </e-button>
    </nuxt-link>
  </div>
</template>
